import React, { useEffect, useCallback, useState } from "react";
import { Grid, Typography, Box, Card, CardActionArea } from "@mui/material";
import countApi from "../../services/home";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "../../redux/loader/actions";
import { showSnackbar } from "../../redux/snackbar/actions";

const NewSubscription = () => {
  const dispatch = useDispatch();
  const handleSubmit = () => {
    console.log("Trigger");
  };

  const [subscriptionData, setSubscriptionData] = useState([
    {
      title: "New Subscription",
      counts: { year: 0, month: 0, week: 0 },
      link: "/subscriptions/new",
    },
    {
      title: "Expired Subscription",
      counts: { year: 0, month: 0, week: 0 },
      link: "/subscriptions/expired",
    },
    {
      title: "Renewed Subscription",
      counts: { year: 0, month: 0, week: 0 },
      link: "/subscriptions/renewed",
    },
  ]);

  useEffect(() => {
    handleSubmit();
  });
  const [countList, setCountList] = useState([]);

  const getAllCountList = useCallback(() => {
    dispatch(showLoader());
    const onSuccess = (res) => {
      dispatch(hideLoader());
      const count = res?.data?.data;
      setCountList(count);
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      setCountList([]);
    };
    countApi.getAllCount().then(onSuccess).catch(onFailure);
  }, []);

  useEffect(() => {
    getAllCountList();
  }, [getAllCountList]);

  useEffect(() => {
    if (countList) {
      setSubscriptionData((prevData) =>
        prevData.map((item) => {
          const key = item.title.toLowerCase().split(" ")[0];
          return {
            ...item,
            counts: countList[key] || { year: 0, month: 0, week: 0 },
          };
        })
      );
    }
  }, [countList]);

  return (
    <Box sx={{ padding: "24px" }}>
      {subscriptionData.map((subscription, index) => (
        <Card
          elevation={3}
          sx={{
            padding: "50px",
            height: "100%",
            margin: "15px 0",
            borderLeft: "5px solid",
            borderImage: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%) 1", // Gradient border
          }}
        >
          <Grid
            container
            spacing={3}
            justifyContent="center"
            alignItems="center"
          >
            <Grid
              item
              xs={12}
              sm={4}
              md={3}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <Typography
                variant="h5"
                sx={{ fontWeight: "bold", textAlign: "center", mb: 0 }}
              >
                {subscription?.title}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Box
                sx={{
                  position: "relative",
                  borderRadius: "16px",
                  padding: "2px",
                  background:
                    "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                }}
              >
                <Card
                  sx={{
                    borderRadius: "14px",
                    padding: "16px",
                    // background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                  }}
                >
                  <CardActionArea href="/subscriptions/year">
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="h6" color="primary">
                        This Year
                      </Typography>
                      <Typography
                        variant="h4"
                        sx={{
                          // color: "#fff",
                          fontWeight: "bold",
                          background:
                            "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                        }}
                      >
                        {subscription?.counts?.year}
                      </Typography>
                    </Box>
                  </CardActionArea>
                </Card>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Box
                sx={{
                  position: "relative",
                  borderRadius: "16px",
                  padding: "2px",
                  background:
                    "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                }}
              >
                <Card
                  sx={{
                    borderRadius: "14px",
                    padding: "16px",
                    // background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                  }}
                >
                  <CardActionArea href="/subscriptions/month">
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="h6" color="primary">
                        This Month
                      </Typography>
                      <Typography
                        variant="h4"
                        sx={{
                          // color: "#fff",
                          fontWeight: "bold",
                          background:
                            "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                        }}
                      >
                        {subscription?.counts?.month}
                      </Typography>
                    </Box>
                  </CardActionArea>
                </Card>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Box
                sx={{
                  position: "relative",
                  borderRadius: "16px",
                  padding: "2px",
                  background:
                    "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                }}
              >
                <Card
                  sx={{
                    borderRadius: "14px",
                    padding: "16px",
                    // background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                  }}
                >
                  <CardActionArea href="/subscriptions/week">
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="h6" color="primary">
                        This Week
                      </Typography>
                      <Typography
                        variant="h4"
                        sx={{
                          // color: "#fff",
                          fontWeight: "bold",
                          background:
                            "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                        }}
                      >
                        {subscription?.counts?.week}
                      </Typography>
                    </Box>
                  </CardActionArea>
                </Card>
              </Box>
            </Grid>
          </Grid>
        </Card>
      ))}
    </Box>
  );
};

export default NewSubscription;
